import { render, staticRenderFns } from "./mh-mobile-labe-select.vue?vue&type=template&id=2822e331"
import script from "./mh-mobile-labe-select.vue?vue&type=script&lang=js"
export * from "./mh-mobile-labe-select.vue?vue&type=script&lang=js"
import style0 from "./mh-mobile-labe-select.vue?vue&type=style&index=0&id=2822e331&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports